import { TemplateNotFound } from './NotFound';

export const Template = {
  NotFound: TemplateNotFound,
};
